import { Link } from "react-router-dom";
import { ArrowRight, Target, Sparkles, MapPin, Trophy, Compass, Clock } from "lucide-react";

const MENU = [
  { id: "facilities",      label: "Facilities",       tag: "01", desc: "Nets · Ground · Gym · Dorm",  icon: Target,
    img: "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=900" },
  { id: "advantage",       label: "Advantage",        tag: "02", desc: "Why we're different",         icon: Sparkles,
    img: "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=900" },
  { id: "life-at-academy", label: "Life at Academy",  tag: "03", desc: "A day inside our academy",    icon: MapPin,
    img: "https://images.unsplash.com/photo-1546519638-68e109498ffc?w=900" },
  { id: "achievements",    label: "Achievements",     tag: "04", desc: "Trophies, placements, alumni", icon: Trophy,
    img: "https://images.unsplash.com/photo-1552667466-07770ae110d0?w=900" },
  { id: "pathway",         label: "Pathway",          tag: "05", desc: "Your ward's journey",         icon: Compass,
    img: "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=900" },
  { id: "sessions",        label: "Sessions",         tag: "06", desc: "What every session covers",   icon: Clock,
    img: "https://images.unsplash.com/photo-1517649763962-0c623066013b?w=900" },
];

export default function Academy() {
  return (
    <div data-testid="academy-page">
      {/* Hero */}
      <section className="relative border-b border-white/8 overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=2400" alt=""
            className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/70 to-[#0B1120]" />
        </div>
        <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24 text-center">
          <div className="font-mono text-xs uppercase tracking-[0.4em] brand-orange mb-4">// The Academy · Navigation</div>
          <h1 className="font-display text-5xl md:text-7xl font-black uppercase tracking-tighter leading-[0.95] max-w-5xl mx-auto">
            Everything about<br />
            <span className="brand-orange">HTP Sports Hub.</span>
          </h1>
          <p className="mt-6 text-lg text-white/70 max-w-2xl mx-auto">
            Click any tile to explore that section of our academy.
          </p>
        </div>
      </section>

      {/* Menu tiles */}
      <section className="border-b border-white/8 bg-[#0B1120] relative -mt-2 z-10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-10 md:py-14">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
            {MENU.map((m) => {
              const Icon = m.icon;
              return (
                <Link
                  key={m.id}
                  to={`/academy/${m.id}`}
                  data-testid={`menu-tile-${m.id}`}
                  className="group relative overflow-hidden border border-white/12 aspect-[4/3] md:aspect-[5/4] text-left transition-all hover:border-brand-orange block"
                >
                  <img src={m.img} alt="" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/50 to-black/20 group-hover:from-black/90" />
                  <div className="absolute top-3 md:top-5 left-3 md:left-5">
                    <span className="font-mono text-[10px] md:text-xs uppercase tracking-widest brand-orange">// {m.tag}</span>
                  </div>
                  <div className="absolute top-3 md:top-5 right-3 md:right-5 h-9 w-9 md:h-11 md:w-11 bg-brand-orange/90 backdrop-blur flex items-center justify-center transition-transform group-hover:rotate-12">
                    <Icon size={16} className="text-black" />
                  </div>
                  <div className="absolute bottom-3 md:bottom-5 left-3 md:left-5 right-3 md:right-5">
                    <div className="font-display text-2xl md:text-3xl font-black uppercase tracking-tighter leading-none mb-1 md:mb-2">
                      {m.label}
                    </div>
                    <div className="text-[11px] md:text-xs text-white/60 mb-2 md:mb-3 line-clamp-1">{m.desc}</div>
                    <div className="inline-flex items-center gap-2 text-[10px] md:text-xs font-mono uppercase tracking-widest text-white/90 group-hover:text-brand-orange transition-colors">
                      Explore <ArrowRight size={12} className="transition-transform group-hover:translate-x-1" />
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-brand-orange text-black">
        <div className="max-w-6xl mx-auto px-5 md:px-8 py-16 md:py-20 grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          <div className="md:col-span-2">
            <div className="font-mono text-xs uppercase tracking-[0.3em] mb-3">// Ready to begin?</div>
            <h2 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tighter leading-[0.95]">
              Book a free trial<br />session this week.
            </h2>
          </div>
          <div className="flex flex-col gap-3 md:items-end">
            <Link to="/enrol" className="bg-black text-white px-8 py-4 font-bold text-sm uppercase tracking-widest hover:bg-white/90 hover:text-black inline-flex items-center gap-2">
              Enrol Your Ward <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
